import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { mapGraphProductToListingProduct } from '../mappers/map-graph-product-to-listing-product.js';
import { GET_PRODUCTS_BY_SKUS } from '../operations/queries/get-products-by-skus.js';

const useGetProductsBySkus = ({ skus  })=>{
    var ref;
    const intl = useIntl();
    const result = useQuery(GET_PRODUCTS_BY_SKUS, {
        variables: {
            skus
        },
        context: {
            headers: {
                'Accept-Language': intl.locale
            }
        }
    });
    if (result.loading) {
        return {
            loading: result.loading
        };
    }
    return {
        listingProducts: result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.getProductsBySKUs.map((prod)=>mapGraphProductToListingProduct(prod, intl)
        ).filter(isDefined).sort(function(a, b) {
            return skus.indexOf(a.masterVariant.sku) - skus.indexOf(b.masterVariant.sku);
        })
    };
};

export { useGetProductsBySkus };
//# sourceMappingURL=use-get-products-by-skus.js.map
